import apiClient from './client';

// Returns { data: [...], pagination: {...} }
export async function fetchLeads(params = {}) {
  const response = await apiClient.get('/leads', { params });
  return response.data;
}

export async function getLead(id) {
  const response = await apiClient.get(`/leads/${id}`);
  return response.data;
}

export async function createLead(payload) {
  const response = await apiClient.post('/leads', payload);
  return response.data;
}

export async function updateLead(id, payload) {
  const response = await apiClient.put(`/leads/${id}`, payload);
  return response.data;
}

export async function deleteLead(id) {
  const response = await apiClient.delete(`/leads/${id}`);
  return response.data;
}

export async function autoAssignLead(id) {
  const response = await apiClient.post(`/leads/${id}/auto-assign`);
  return response.data;
}

export async function bulkAutoAssignLeads(leadIds) {
  const payload = Array.isArray(leadIds) ? { lead_ids: leadIds } : {};
  const response = await apiClient.post('/leads/bulk/auto-assign', payload);
  return response.data;
}

export async function getSuggestedAgents(id) {
  const response = await apiClient.get(`/leads/${id}/suggested-agents`);
  return response.data;
}

export async function assignLead(id, agentId) {
  const response = await apiClient.post(`/leads/${id}/assign`, { agent_id: agentId });
  return response.data;
}
